import { Avatar, Dialog, DialogContent, Stack } from "@mui/material";
import React from "react";

//  five colours for the five days of the week
import { deepPurple, deepOrange, green, blue, red } from "@mui/material/colors";

const colours = [deepPurple, deepOrange, green, blue, red];
const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

export function TaskListScheduledDay({ day, onClick, ...props }) {
  if (day === undefined || day === null || day === "") {
    return null;
  }
  // get day of week
  const dayName = isNaN(day) ? day : daysOfWeek[day];
  // get first letter of day
  let letters = dayName[0];

  // if tuesday or thursday, get first two letters
  if (dayName === "Tuesday" || dayName === "Thursday") {
    letters = dayName.slice(0, 2);
  }

  const dayNumber = isNaN(day) ? daysOfWeek.indexOf(day) : day;
  // get colour
  const colour = colours[dayNumber % colours.length];
  return (
    <Avatar {...props} sx={{ bgcolor: colour["500"], width: 32, height: 32 }}>
      {letters}
    </Avatar>
  );
}
